import React, { FC, useEffect, useState } from 'react';
import { HomepageRoot } from './styled';
import Intro from './components/intro/Intro';
import Marquee from './components/marquee/Marquee';
import Description from './components/description/Description';
import Opportunities from './components/opportunities/Opportunities';
import Computer from 'components/computer/Computer';
import Faq from './components/faq/Faq';
import Committee from './components/сommmittee/Committee';
import Sponsors from './components/sponsors/Sponsors';
import ConferenceWrapper from './components/conference-wrapper/ConferenceWrapper';
import MediaBlock from './components/media-block/MediaBlock';
import ArchivedConferences from './components/archived-conferences/ArchivedConferences';
import AgreementAccept from './components/agreement-accept/AgreementAccept';
import { DefaultTheme } from 'styled-components';
import { Conference } from 'types/index';
import { getApiService, getConferenceApi, getStorageService } from 'services/index';

const HomePage: FC<{ theme: DefaultTheme }> = ({ theme }) => {
    const [currentConference, setCurrentConference] = useState<Conference | null>(null);
    const storageService = getStorageService();
    const apiService = getApiService(storageService);
    const conferenceApi = getConferenceApi(apiService);
    useEffect(() => {
        conferenceApi.getCurrent().then((response) => setCurrentConference(response.data));
    }, []);

    return (
        <HomepageRoot>
            <Intro />
            <Marquee />
            <Sponsors />
            <Description />
            <Computer />
            <Opportunities />
            <MediaBlock />
            <Committee />
            {<ConferenceWrapper conferenceId={currentConference?.id} />}
            <Faq />
            <ArchivedConferences currentId={currentConference?.id} />
            <AgreementAccept theme={theme} />
        </HomepageRoot>
    );
};

export default HomePage;
